<template>
  <div class="pa-2">
    <div class="d-flex justify-center">
      <router-link to="/" class="d-flex justify-center">
        <img alt="MLR Logo" class="mlr_logo" src="../../assets/mlr-logo.png" />
      </router-link>
    </div>


    <EpreuvesResultsLinks></EpreuvesResultsLinks>

    <div class="d-flex flex-column justify-center align-center mt-5">
      <p style="font-size: 12px">
        <b>Générée par</b>
      </p>
      <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png"
          style="display: inline; width: 80px" /></a>
    </div>
  </div>
</template>

<script>
import EpreuvesResultsLinks from "@/components/App/EpreuvesResultsLinks.vue";

export default {
  name: "NavigationDrawer",
  components: {
    EpreuvesResultsLinks,

  },
};
</script>

<style lang="scss" scoped>
.mlr_logo {
  width: min(100%, 150px);
  height: auto;
}
</style>